import { JackpotMetadataPrizeDto } from '../../app/store/api/jackpotApi';

export enum LotteryTurnType {
  InTurn = 'InTurn',
  AllAtOnce = 'AllAtOnce',
}

export enum SuperTicketType {
  TICKET_5 = 'TICKET_5',
  TICKET_10 = 'TICKET_10',
  TICKET_150 = 'TICKET_150',
  TICKET_240 = 'TICKET_240',
  TICKET_980 = 'TICKET_980',
  TICKET_2000 = 'TICKET_2000',
  METALLIC_IRON_160 = 'METALLIC_IRON_160',
  METALLIC_BRONZE_360 = 'METALLIC_BRONZE_360',
  METALLIC_SILVER_560 = 'METALLIC_SILVER_560',
}

export type SuperTicketState = {
  superTicketType: SuperTicketType;
  multiplier: number;
  multiplyPlaces: number[]; // на какие места действует умножение на muliplier
};

export interface GameRoom {
  id: string;
  againGameId?: string;
  bet: string;
  seedHash: string;
  state: {
    numPlayers: number;
    isGameStarted: boolean;
    startedAt?: Date;
    superTicketState?: SuperTicketState;
    gameNumber?: string;
  };
  settings: { turnType: LotteryTurnType };
}

export interface LotteryGameInfo {
  bet: string;
  metadata: {
    prizes: JackpotMetadataPrizeDto[];
  };
}

export interface LotteryInfo {
  numNumbers: number;
  numPlayers: number;
  eachPlayerPicks: number;
  possibleBets: string[];
  games: LotteryGameInfo[];
}

export interface LotteryJoinedPlayers {
  players: number[];
  gameRoomId: string;
}

export interface LotteryFrontJackpot {
  count: number;
  jackpotSlug: string;
  metadata: {
    drawAmount: string;
    ticketsCount: number;
  };
}

export interface LotteryFinishedState {
  gameRoomId: string;
  autoFinish: boolean;
  seed: {
    localSeed: string;
    hash: string;
  };
  winners: {
    prize: {
      money: string;
      jackpots: LotteryFrontJackpot[];
    } | null;
    winNumber: number;
    player: number;
  }[];
  winnerForMatches?: {
    player: number;
    prize: {
      orderedMatches: string;
      unorderedMatches: string;
      totalForMatches: string;
    };
  };
}

export interface LotteryAllNumberPicked {
  pickedNumber: number;
  gameRoomId: string;
  myPick: boolean;
  auto: boolean;
}

export interface LotteryTurnNumbersPicked {
  pickedNumbers: number[];
  gameRoomId: string;
  myPick: boolean;
  auto: boolean;
}

export interface LotteryTurnNextTurn {
  gameRoomId: string;
  myTurn: boolean;
}

export interface LotteryGameRoomWinner {
  prize: {
    money: string;
    jackpots: LotteryFrontJackpot[];
  } | null;
  winNumber: number;
  player: number;
}
